import React, { useContext } from "react";
import style from "./index.module.scss";
import { ModalProps } from "antd/es/modal";
import { Button, Input, message, Modal } from "antd";
import CommonTable from "components/CommonTable";
import { ColumnProps } from "antd/es/table";
import {
    adjustRandomGroupMemberAdd,
    GroupType,
    NoGroupStudentListItem
} from "service/group";
import MultiLineColumn from "components/MultiLineColumn";
import OverLengthColumn from "components/OverLengthColumn";
import useSelection from "../../../../../../../utils/v2/useSelection";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import { groupIdAtom, GroupSettingsContext } from "../../../../store";
import { useAtomValue } from "jotai";
import useRequestFn from "utils/useRequestFn";
import { addGroupMember } from "service/group";
import SubmitError from "components/SubmitError";

interface MembersModalProps extends ModalProps {
    onOk: () => void;
    onCancel: () => void;
    type?: GroupType;
    randomGroupKey?: string;
}

export default function MembersModal({
    onOk,
    onCancel,
    randomGroupKey,
    type = GroupType.base,
    ...props
}: MembersModalProps) {
    const { Search } = Input;
    const groupId = useAtomValue(groupIdAtom);
    const {
        filterNoGroupList,
        noGroupLoading,
        updateNoGroupStudent,
        updateGroupList,
        setNoGroupSearch
    } = useContext(GroupSettingsContext);
    const rowSelection = useSelection();

    const [save, { loading }] = useRequestFn(addGroupMember);
    const [saveRandom, { loading: randomLoading }] = useRequestFn(
        adjustRandomGroupMemberAdd
    );

    //添加成员
    const onSave = async () => {
        const params = filterNoGroupList
            .filter(item => rowSelection.selected.includes(item.memberNo))
            .map(item => ({
                groupId: groupId === -1 ? undefined : groupId,
                memberNo: item.memberNo,
                name: item.name,
                college: item.college,
                major: item.major,
                className: item.className,
                isGroupLeader: "0"
            }));
        try {
            switch (type) {
                case GroupType.base:
                    await save(params);
                    break;
                case GroupType.random:
                    await saveRandom(
                        params.map(item => {
                            return { ...item, randomGroupKey: randomGroupKey! };
                        })
                    );
                    break;
            }
            await updateGroupList();
            await updateNoGroupStudent();
            onOk();
            message.success("添加成功");
        } catch (e) {
            ResultMessage.error(
                <SubmitError title="添加失败" content={errorMessage(e)} />,
                { width: 300 }
            );
        }
    };

    const columns: ColumnProps<any>[] = [
        {
            title: "学生信息",
            dataIndex: "name",
            render: (text: string, record: NoGroupStudentListItem) => (
                <MultiLineColumn name={text} no={record.memberNo} />
            )
        },
        {
            title: "学院",
            dataIndex: "college",
            align: "center",
            render: (text: string) => <OverLengthColumn value={text} />
        },
        {
            title: "班级",
            dataIndex: "className",
            align: "center",
            render: (text: string) => <OverLengthColumn value={text} />
        }
    ];

    const footer = (
        <div className={style.footer}>
            <div className={style.num}>
                已选<span> {rowSelection.selected.length} </span>人
            </div>
            <div>
                <Button key="back" onClick={onCancel}>
                    取消
                </Button>
                <Button
                    key="submit"
                    type="primary"
                    loading={loading || randomLoading}
                    onClick={onSave}>
                    确定
                </Button>
            </div>
        </div>
    );
    return (
        <Modal
            title="添加组员"
            onCancel={onCancel}
            maskClosable={false}
            confirmLoading={false}
            className={style.root}
            width={610}
            {...props}
            onOk={onOk}
            footer={footer}>
            <div className={style.tools}>
                <Search
                    placeholder="请输学生姓名或学号"
                    onSearch={value => setNoGroupSearch(value)}
                    style={{ width: 200 }}
                />
            </div>
            <CommonTable
                rowKey="memberNo"
                columns={columns}
                rowSelection={{
                    selectedRowKeys: rowSelection.selected as number[],
                    onChange: rowSelection.setSelected
                }}
                dataSource={filterNoGroupList}
                pagination={false}
                loading={noGroupLoading}
                scroll={{ y: 345 }}
                height="320px"
            />
        </Modal>
    );
}
